<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title"><a id="pageiii"></a>PATRIOTIC GORE</h1>
<p class="tp-center">STUDIES IN THE LITERATURE<br/>OF THE AMERICAN CIVIL WAR</p>
<p class="center">BY</p>
<p class="tp-center">EDMUND WILSON</p>
<p class="line">
</p><p class="center"><i>Without the shedding of blood, there is no remission of sins</i></p>
<p class="right"><span class="small">JOHN BROWN</span></p>
<div class="title">
<p class="nonindent"><i>The despot’s heel is on thy shore,</i></p>
<p class="right1"><i>Maryland!</i></p>
<p class="nonindent"><i>His torch is at thy temple door,</i></p>
<p class="right"><i>Maryland!</i></p>
<p class="nonindent"><i>Avenge the patriotic gore</i></p>
<p class="nonindent"><i>That flecked the streets of Baltimore,</i></p>
<p class="nonindent"><i>And be the battle-queen of yore,</i></p>
<p class="right"><i>Maryland! My Maryland!</i></p>
<p class="right"><span class="small">SONG OF THE CONFEDERATE SOUTH</span></p>
</div>
<p class="tp-center1"><img alt="" src="OEBPS/images/logo.jpg"/><br/>Farrar, Straus &amp; Giroux</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?724b3ec1